export enum WebErrorCode {
  GENERIC_FORBIDDEN = '403000',
  UNKNOWN_USER = '403001',
}
